// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__success-topic[data-v-d868137c]{color:#2dac7e;font-weight:700;margin:40px 0}.text__success-description[data-v-d868137c]{font-weight:700;margin-bottom:40px}.detail-container[data-v-d868137c]{padding:1.5rem;max-width:511px;border-radius:.65rem;box-shadow:0 4px 8.8px 0 rgba(166,166,185,.55)}", ""]);
// Exports
module.exports = exports;
